<template>
  <transition name="slide-up">
    <!-- Gradient border wrapper -->
    <div v-if="showBanner" class="fixed right-0 bottom-0 left-0 w-full" style="z-index: 9999">
      <div class="relative">
        <div class="absolute top-0 left-0 z-10 h-[2px] w-full bg-gradient-to-r from-mauve-500 to-navy-blue-500"></div>

        <!-- Content -->
        <div class="relative w-full overflow-hidden bg-eerie-black-500/10 p-5 backdrop-blur-[50px]">
          <div class="flex w-full flex-col items-center justify-between gap-6 lg:flex-row lg:gap-16">
            <!-- Cookie Message -->
            <div class="flex min-w-0 flex-1 flex-col gap-2">
              <h3 class="font-exo-bold text-xl text-white lg:text-2xl">We’ve got cookies</h3>
              <div>
                <p class="mb-3 text-sm text-white lg:text-base">
                  We use cookies to keep VibeTeams running smoothly, understand what’s working, and make your experience better over time. Some
                  cookies are essential for the platform to function, others help us improve the vibe.
                </p>
                <p class="text-sm text-white lg:text-base">
                  Learn more in our
                  <span> <InertiaLink href="/privacy-policy" class="text-mauve-500 underline">Privacy Policy</InertiaLink> </span>.
                </p>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="flex w-full flex-col gap-3 lg:w-auto lg:flex-shrink-0 lg:flex-row">
              <UiButton type="button" variant="gradient" class="w-full whitespace-nowrap lg:w-[240px]" :disabled="loading" @click="handleAccept">
                {{ loading ? 'Accepting...' : 'Accept Cookies' }}
              </UiButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { Button as UiButton } from '@/components/ui/button';
import { apiGetJson, apiPostJson } from '@/utils/api';
import { logger } from '@/utils/logger';
import { usePage } from '@inertiajs/vue3';
import { route } from 'ziggy-js';

export default {
  name: 'CookieConsent',

  components: {
    UiButton,
  },

  data() {
    return {
      showBanner: false,
      loading: false,
    };
  },

  computed: {
    cookieConsentEnabled() {
      return usePage().props.cookieConsentEnabled as boolean;
    },
  },

  async mounted() {
    // Don't show banner or make API calls if cookie consent is disabled
    if (!this.cookieConsentEnabled) {
      return;
    }

    await this.checkConsentStatus();
  },

  methods: {
    async checkConsentStatus() {
      try {
        const response = await apiGetJson(route('cookie-consent.status'));

        this.showBanner = !response.has_consent;
      } catch (error) {
        logger.error('Error checking cookie consent status:', error);
        // Default to showing the banner if there's an error
        this.showBanner = true;
      }
    },

    async handleAccept() {
      this.loading = true;

      try {
        await apiPostJson(route('cookie-consent.accept'));
        this.showBanner = false;
      } catch (error) {
        logger.error('Error accepting cookie consent:', error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
  transition:
    transform 0.3s ease-out,
    opacity 0.3s ease-out;
}

.slide-up-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-enter-to,
.slide-up-leave-from {
  transform: translateY(0);
  opacity: 1;
}
</style>
